<template>
    <div class="main-notperm d-flex flex-column justify-content-center align-items-center">
        <!-- <img alt="MM logo" src="/assets/images/favicon.png" /> -->
        <h1 class="text-danger fw-bold fs-3"><i class="fas fa-exclamation-triangle"></i> Bu səhifəyə baxış səlahiyyətiniz yoxdur !</h1>
    </div>
</template>

<script>

export default {
    title: "Baxış səlahiyyəti",
    name: "NotPermissionPage",
    components: {},
    setup(){
        return {};
    }
};
</script>

<style lang="scss">
    .main-notperm {
        height: calc( 100vh - 150px );
    }
    .main-notperm img{
        width: 150px;
        margin-bottom: 20px;
        // background: linear-gradient(70deg, #f00, #000);
    }
</style>
